import { render, staticRenderFns } from "./Ordercontract.vue?vue&type=template&id=7776b07a&scoped=true&"
import script from "./Ordercontract.vue?vue&type=script&lang=js&"
export * from "./Ordercontract.vue?vue&type=script&lang=js&"
import style0 from "./Ordercontract.vue?vue&type=style&index=0&id=7776b07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7776b07a",
  null
  
)

export default component.exports